<div class="container">
    <div>
        <img (click)="navigateHome()" src="assets/images/Gallagher Logo -White Transparent.png" />
    </div>
</div>